var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "navigation__item navigation__item__dropdown nav-item" },
    [
      _c(
        "a",
        {
          staticClass:
            "navigation__item__link navigation__item__link--dropdown",
          class: { "navigation__item__link--dropdown--rotate": _vm.isOpen },
          on: { click: _vm.dropDown },
        },
        [_vm._t("title")],
        2
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "dropdown__box dropdown__box__bg--white",
          class: {
            "dropdown__box--show": _vm.isOpen,
            "d-none": _vm.isNotLoaded,
          },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }